import React, { useMemo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { Entity } from "@common/types/entity";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { EntityAvatarGroup } from "@components/avatar/EntityAvatarGroup";
import { useEntitiesById } from "@hooks/useEntities";
import { GLViewRow } from "../glViewTypes";

export const GLEntityCell = React.memo(function GLEntityCell({
    row,
}: CellContext<ViewTableFeatures, GLViewRow, unknown>): React.ReactElement {
    const original = row.original;
    const entitiesById = useEntitiesById();

    const entities = useMemo<Entity[]>(() => {
        if (original.rowKind === "account") {
            return (original.entityIds ?? [])
                .map((id) => entitiesById.get(id))
                .filter((e): e is Entity => e !== undefined);
        }
        if (original.rowKind === "transaction" && original.transaction) {
            const entity = entitiesById.get(original.transaction.entityId);
            return entity ? [entity] : [];
        }
        return [];
    }, [original, entitiesById]);

    if (entities.length === 0) {
        return <ViewTableCell />;
    }

    return (
        <ViewTableCell>
            <EntityAvatarGroup entities={entities} max={3} size="xs" />
        </ViewTableCell>
    );
});
